<div rvSpinner="onedrive-file-picker-modal" [rvShowSpinner]=true>
  <iframe
    id="filePickerIFrame"
    class="file-picker-iframe"
    frameborder="0"
    sandbox="allow-forms allow-same-origin allow-scripts"
  >
  </iframe>
</div>
